import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment'
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as Actions from '../store/actions';
import * as paramActions from '../../../components/paramHistory/store/actions';
import { fade } from '@material-ui/core/styles/colorManipulator';
import {
    Grid,
    Tabs,
    Tab,
    IconButton,
    Icon,
    AppBar,
    Typography,
    List,
    ListItem,
    Card,
    CardContent,
    InputBase,
    Tooltip,
    Toolbar,
    InputAdornment,
    Select,
    Input,
    OutlinedInput,
    MenuItem,
    FormHelperText,
    InputLabel,
} from '@material-ui/core';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import { withRouter } from 'react-router-dom';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import SearchIcon from '@material-ui/icons/Search';
import EventChip from './EventChip';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    draggableList: {
        height: '775px',
        background: theme.palette.background.default,
        padding: grid,
        overflow: 'auto',
    },
    eventCard: {
        width: '100%',
    },
    eventCardContent: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        alignContent: 'center',
        padding: '8px'
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing.unit,
            width: 'auto',
        },
    },
    searchIcon: {
        width: theme.spacing.unit * 9,
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
        width: '100%',
    },
    inputInput: {
        paddingTop: theme.spacing.unit,
        paddingRight: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 10,
        transition: theme.transitions.create('width'),
        width: '100%',

    },
})

const grid = 8;
const getListStyle = (isDraggingOver) => {
    if (isDraggingOver) {
        return {
            background: 'lightblue',
        }
    }
};

class EventList extends Component {
    state = {
        current_tab: 0,
        event_search: '',
    }

    handleTabChange = (event, value) => {
        this.setState({
            current_tab: value,
        });
    }

    handleSearchChange = (event) => {
        this.setState({
            event_search: event.target.value,
        });
    }

    handleClearSearch = () => {
        this.setState({
            event_search: '',
        });
    }

    getCardStyle = (color) => {
        return {
            borderRadius: 4,
            borderWidth: 2,
            borderColor: color,
        }
    }

    getEventCard = (event_info) => {
        const { classes, isUnscheduled } = this.props;

        if (isUnscheduled) {
            return (
                <Card
                    key={event_info.id}
                    className={classes.eventCard}
                    style={this.getCardStyle(event_info.Color)}
                >
                    <CardContent className={classes.eventCardContent}>
                        <Typography>{event_info.title}</Typography>
                        <Tooltip title={event_info.desc || ''}>
                            <Icon>info</Icon>
                        </Tooltip>
                    </CardContent>
                </Card>
            )
        } else {
            return (
                <EventChip
                    removeEventFromCalendar={this.props.removeEventFromCalendar}
                    event={event_info}
                    key={event_info.id}
                    onClickEvent={this.props.onClickEvent}
                    alreadySelected={event_info.alreadySelected}
                />
            )
        }
    }

    getEventList = (event_list, event_type) => {
        const { classes, unscheduledEvents, isUnscheduled } = this.props;
        const { event_search } = this.state;

        const filtered_event_list = event_list
            .filter((event_info) => {
                // Filter based on user search
                return event_info.title.toLowerCase().includes(event_search.toLowerCase());
            }).filter((event_info) => {
                return unscheduledEvents.filter((selected_event_info) => {
                    // Filter based on selected events
                    return selected_event_info.eventType === event_info.eventType && selected_event_info.rel_id === event_info.rel_id;
                }).length === 0;
            });

        if (isUnscheduled) {
            return (
                <Droppable droppableId="event_list">
                    {(provided, snapshot) => (
                        <div
                            ref={provided.innerRef}
                            className={classes.draggableList}
                            style={getListStyle(snapshot.isDraggingOver)}
                        >
                            <List>
                                {filtered_event_list.map((event_info, index) => {
                                    if (!event_info.alreadySelected) {
                                        return (
                                            <Draggable
                                                key={event_info.event_id}
                                                draggableId={event_info.event_id}
                                                index={index}
                                                listType='event_list'
                                            >
                                                {(provided, snapshot) => (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                    >
                                                        <ListItem>
                                                            {this.getEventCard(event_info)}
                                                        </ListItem>
                                                    </div>
                                                )}
                                            </Draggable>
                                        );
                                    }
                                })}
                                {provided.placeholder}
                            </List>
                        </div>
                    )}
                </Droppable>
            )
        } else {
            return (
                <div
                    className={classes.draggableList}
                >
                    <List>
                        {filtered_event_list.map((event_info, index) => {
                            return (
                                <ListItem key={index}>
                                    {this.getEventCard(event_info)}
                                </ListItem>
                            );
                        })}
                    </List>
                </div>
            );
        }
    }

    getTabContent = (current_tab) => {
        const { leftItemsAssignment, leftItemsQuiz } = this.props;

        switch (current_tab) {
            case (0): // Quizzes
                {
                    return this.getEventList(leftItemsAssignment, 'quiz');
                }

            case (1): // Assignments
                {
                    return this.getEventList(leftItemsQuiz, 'assignment');
                }
        }
    }

    handleAddClick = (header, lesson_id) => {
        const {currentLesson, paramHistory} = this.props;
        let startingPoint = 'lesson';
        if (paramHistory.active) {
            startingPoint = paramHistory.startingPoint
        }
        this.props.updateParams({ active: true, lesson_id: parseInt(currentLesson.lesson_id), LessonName: currentLesson.LessonName, startingPoint: startingPoint})
        this.props.saveLesson(this.props.currentLesson, this.props.currentLessonAssignmentList, this.props.currentLessonQuizList, this.props.unscheduledEvents, this.props.auth_id, this.props.companies);
        if (header === 'assignment') {
            this.props.history.push('/assignment/create')
        }
        else {
            this.props.history.push('/quiz/create')
        }
    }

    render() {
        const { classes, events, leftItemsAssignment, leftItemsQuiz, unscheduledEvents, currentLessonAssignmentList } = this.props;
        const { current_tab, event_search } = this.state;

        return (
            <React.Fragment>
                <AppBar position="static">
                    <Toolbar className={classes.eventCardContent}>
                        <Tabs
                            value={current_tab}
                            onChange={this.handleTabChange}
                            // indicatorColor="inherit"
                            // textColor="inherit"
                            variant="fullWidth"
                        >
                            <Tab label="Assignments" />
                            <Tab label="Quizzes" />
                        </Tabs>

                        <div style={{ float: 'right' }}>{<IconButton
                            style={{ padding: '0px', margin: '0px',  backgroundColor: 'white' }}
                            onClick={() => this.handleAddClick(current_tab === 0 ? 'assignment' : 'quiz', this.props.lesson_id)}
                        >
                            <Icon>add</Icon>
                        </IconButton>}</div>
                    </Toolbar>
                </AppBar>
                <AppBar position="static" style={{ paddingLeft: '20px', paddingRight: '20px', paddingBottom: '5px', paddingTop: '5px' }}>
                    <div className={classes.search}>
                        <div className={classes.searchIcon}>
                            <SearchIcon />
                        </div>
                        <InputBase
                            placeholder="Search…"
                            value={event_search}
                            onChange={this.handleSearchChange}
                            classes={{
                                root: classes.inputRoot,
                                input: classes.inputInput,
                            }}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="Clear Search"
                                        onClick={this.handleClearSearch}
                                        style={{ padding: '2px', marginLeft: '5px', marginRight: '5px' }}
                                        color="inherit"
                                    >
                                        <Icon style={{ fontSize: 15 }}>clear</Icon>
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                    </div>
                </AppBar>
                <div>{this.getTabContent(current_tab)}</div>
            </React.Fragment>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateParams: paramActions.updateCourseBuilderParams,
        saveLesson: Actions.saveLesson,
        addUnscheduledEvent: Actions.addUnscheduledEvent,
        moveCard: Actions.moveCard,
        removeEventFromCalendar: Actions.removeEventFromCalendar,
        addUnscheduledEvent: Actions.addUnscheduledEvent,
        moveUnscheduledEvent: Actions.moveUnscheduledEvent,
        removeUnscheduledEvent: Actions.removeUnscheduledEvent,
        setUnscheduledEventRelation: Actions.setUnscheduledEventRelation,
    }, dispatch);
}

function mapStateToProps({ paramHistory }) {
    return {
        paramHistory: paramHistory.courseBuilder
    }
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(EventList)));



// WEBPACK FOOTER //
// src/main/content/lesson/ScheduleComponents/EventList.js